import React from 'react';
import Navbar from '../components/Navbar.js';
import Footer from '../components/Footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import BannerImage from '../components/img/clinical-banner.png';
import Card1 from '../components/img/clinical-card-1.png';
import Card2 from '../components/img/clinical-card-2.png';
import '../styles/pages.css';

function ClinicalNutrition() {
    return (
        <div>
            {/* Navbar */}
            <Navbar />
            {/* Navbar Ending */}

            {/* Page Content starts here */}
            <section className="page-section">
                <div className="section-content">
                    <p className='page-heading'>Clinical Nutrition </p>

                    <div className="d-none d-md-block"> {/* Only works in Desktop */}
                        <p className="page-subtitle">
                            Personalized dietary guidance for enhanced patient health
                            <br />
                            and wellness, tailored by our expert nutrition team.
                        </p>
                    </div>

                    <div className="d-md-none mb-2">{/* Only works in mobiles */}
                        <p className="page-subtitle">
                        Personalized dietary guidance for enhanced patient health and wellness, tailored by our expert nutrition team.
                        </p>
                    </div>

                    <div className="page-box">
                        <div className="box-content">
                            <p>
                                Caritas Matha Hospital's Clinical Nutrition services provide personalized
                                dietary guidance tailored to enhance patient health and wellness. Our team
                                of nutrition experts offers comprehensive assessments and customized meal plans,
                                integrating the latest research and dietary guidelines.
                            </p>
                        </div>
                        <div className="box-image">
                            <img src={BannerImage} alt="Clinical Nutrition" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="page-content-section">
                <div className='page-content'>
                    <p className='page-content-heading'>
                        Expert-Led Clinical Nutrition for Customized Dietary Solutions <br />
                        at Caritas Matha Hospital
                    </p>
                    <br />
                    <div className='page-details'>
                        <p>
                            Led by a team of expert dieticians, the Clinical Nutrition department at
                            Caritas Matha Hospital specializes in providing customized, guideline-based
                            dietary plans tailored to meet the unique needs of each patient. These plans
                            are meticulously designed based on individual health conditions and nutritional
                            requirements. The department plays a pivotal role across all medical specialties
                            by assessing, monitoring, and optimizing the nutritional status of patients,
                            including those requiring intravenous feeding.
                        </p>
                        <br />
                        <p>
                            Our dieticians are extensively trained in all aspects of diet and nutrition,
                            offering expert advice on healthy eating habits, optimal weight management,
                            and lifestyle disease prevention such as diabetes, obesity, and hypertension.
                            They work closely with patients to empower them with the knowledge and tools
                            needed to achieve long-term health and well-being.
                        </p>
                        <br />
                        <h5>Nutrition Clinic</h5>
                        <br />
                        <p>
                            The Nutrition Clinics under our Clinical Nutrition department provide personalized,
                            guideline-based dietary advice. Each patient undergoes a detailed assessment
                            considering their current physical and medical condition, nutritional needs,
                            and expected recovery trajectory. This holistic approach ensures tailored diet plans
                            that support optimal health outcomes.
                        </p>
                        <br />
                        <div className="clinical-card">
                            <div className="clinical-card-image">
                                <img src={Card1} alt="Card Image" />
                            </div>
                            <div className="clinical-card-content">
                                <h6>Diabetes Clinic</h6><br />
                                <p>
                                    In our Diabetes Clinic, dieticians collaborate with Diabetologists and
                                    Endocrinologists to develop personalized diet plans aimed at controlling
                                    and maintaining blood sugar levels effectively. These plans outline specific
                                    dietary recommendations to manage diabetes, emphasizing foods to include and
                                    avoid to support overall health and wellness.
                                </p>
                            </div>
                        </div>
                        <div className="clinical-card">
                            <div className="clinical-card-image">
                                <img src={Card2} alt="Card Image" />
                            </div>
                            <div className="clinical-card-content">
                                <h6>Wellness Nutrition Clinic</h6><br />
                                <p>
                                    The Wellness Nutrition Clinic focuses on assessing patients' health status
                                    and lifestyle in detail. Based on comprehensive evaluations, our dieticians
                                    create customized diet plans to meet daily nutritional requirements, maintain
                                    optimal body weight, and enhance overall health. These plans include
                                    recommendations to improve physical activity levels, optimize calorie
                                    expenditure, and prevent fat accumulation, promoting holistic wellness.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="more-services">
                    <p className="more-services-heading">More Services</p>
                    <div className='more-services-links'>
                        <a href="/radiology-laboratory"><p> Radiology & Laboratory</p></a>
                        <a href="/blood-bank"><p> Blood Bank</p></a>
                        <a href="/insurance-partners"><p> Insurance Partners</p></a>
                        <a href="/caritas-mortuary-services"><p> Caritas Mortuary Services</p></a>
                        <a href="/pastoral-care"><p> Pastoral Care</p></a>
                        <a href="/caritas-home-care"><p> Caritas Home Care</p></a>
                        <a href="https://www.caritashospital.org/health-checkup-packages"><p> Health Checkup Packages</p></a>
                        <a href="/video-consultation"><p> Video Consultation</p></a>
                    </div>
                </div>
            </section>

            {/* Page content ends here */}

            {/* Footer */}
            <Footer />
            {/* Footer Ending */}
        </div>
    );
}

export default ClinicalNutrition;